import styled from 'styled-components'
import { Container } from '../Container'

const StyledArchivesPageMain = styled.main`
  position: relative;
  margin-top: 150px;
  margin-bottom: 48px;

  h1 {
    color: ${(props) => props.theme.v2.onSurface.text};
    font-family: ${(props) => props.theme.v2.font.nantes};
    font-size: ${(props) => props.theme.v2.typography.body.xl.fontSize};
    line-height: ${(props) => props.theme.v2.typography.body.xl.lineHeight};
    margin-bottom: 24px;

    @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
      font-size: ${(props) => props.theme.v2.typography.body.l.fontSize};
      line-height: ${(props) => props.theme.v2.typography.body.l.lineHeight};
    }
  }

  h2 {
    color: ${(props) => props.theme.v2.onSurface.text};
    font-family: ${(props) => props.theme.v2.font.lotaGrotesqueRegular};
    font-size: ${(props) => props.theme.v2.typography.body.m.fontSize};
    line-height: ${(props) => props.theme.v2.typography.body.m.lineHeight};
    margin-bottom: 24px;
  }

  p {
    font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    margin-top: 105px;
  }

  ol {
    padding: 0;
    list-style-type: none;

    li {
      padding: 27px 0;
      border-bottom: 2px solid ${(props) => props.theme.v2.interactive.surface};
      border-left: none;
      border-right: none;
      font-size: ${(props) => props.theme.v2.typography.body.xs.fontSize};
      line-height: ${(props) => props.theme.v2.typography.body.xs.lineHeight};
      font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};

      a {
        display: flex;
        justify-content: space-between;
        color: ${(props) => props.theme.v2.interactive.bright};
        font-size: ${(props) => props.theme.v2.typography.body.m.fontSize};
        line-height: ${(props) => props.theme.v2.typography.body.m.lineHeight};
        font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};

        &:hover {
          color: ${(props) => props.theme.v2.interactive.subdued};
        }
      }
    }
  }
`

export const ArchivesPageMain = ({ children }) => (
  <StyledArchivesPageMain id="main-content">
    <Container $size="narrow">{children}</Container>
  </StyledArchivesPageMain>
)
